import { mapGetters, mapActions } from 'vuex'

const moduleName = 'quickinvoices'

export default {
  computed: {
    ...mapGetters(moduleName, {
      returnRoute: 'returnRoute',
      snapshots: 'snapshots',
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff',
      readOnlyView: 'readOnlyView'
    }),
    ...mapGetters(['licenceExpired'])
  },
  methods: {
    ...mapActions(moduleName, ['getStoreItem', 'addStoreItem', 'saveSnapshot', 'clearSnapshots', 'setReturnRoute', 'setReadOnlyView']),
    ...mapActions(moduleName, ['setAsset', 'setContactId']),
    ...mapActions('contacts', { setContactReturnRoute: 'setReturnRoute', addStoreContact: 'addStoreItem', editStoreContact: 'editStoreItem' }),
    ...mapActions('customers', { setCustomerReturnRoute: 'setReturnRoute', editStoreCustomer: 'editStoreItem', addStoreCustomer: 'addStoreItem' }),
    ...mapActions('insurers', { setInsurerReturnRoute: 'setReturnRoute', editStoreInsurer: 'editStoreItem' }),
    ...mapActions('printpreview', { setPrintPreviewReturnRoute: 'setReturnRoute', addEmailer: 'addEmailer', removeEmailer: 'removeEmailer' }),
    ...mapActions('printpreview', { addReportParameters: 'addParameters', removeReportParameters: 'removeParameters' })
  }
}
